<div *ngIf="paymentSuccess" class="container">
  <!-- <div class="container"> -->
  <div class="row d-flex justify-content-center py-3">
    <div class="col-lg-8 col-md-10 col-sm-12 col-12 text-center">
      <img src="assets/check.png" alt="" class="img-fluid" style="width: 150px; margin-top: 50px;">
      <h2 class="text-center lifedi-color my-4">ชำระเงินสำเร็จ</h2>

      <h4 class="text-center my-4">Payment ID: {{ paymentID }}</h4>
      <h5 class="text-center my-4">ระบบ Life Di จะพาคุณกลับไปหน้าแรกในอีก</h5>
      <countdown [config]="{leftTime: 5}" (event)="handleEvent($event)"></countdown>
      <h5 class="text-center text-primary my-4"><a (click)="redirect()">ออกจากหน้านี้</a></h5>
      <h5>
      </h5>

    </div>
  </div>
</div>

<div *ngIf="isPrint">
  <lifedi-payment-receipt [receiptDetail]="receiptDetail" [accountId]="accountId"
    [isSendMail]="true" (sendEmail)="sendMail($event)"></lifedi-payment-receipt>
</div>